import { render, staticRenderFns } from "./news-form.vue?vue&type=template&id=13c8d49e&"
import script from "./news-form.vue?vue&type=script&lang=js&"
export * from "./news-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports